// Choose a physician from NGF's list (Admin → Physicians). Used wherever a paper signature is recorded. An expired license is
// marked and confirmed, not blocked (older forms signed while licensed still import).
import { useData } from '../lib/useData.ts';

export interface PhysicianOpt { id: string; label: string; expired: boolean; licenseExpires: string | null; specialty: string | null; licenseState?: string; notes?: string | null }

export function PhysicianSelect({ id, value, onChange, suggestedId, disabled, required }: {
  id?: string; value: string; onChange: (id: string) => void; suggestedId?: string | null; disabled?: boolean; required?: boolean;
}) {
  const list = useData<PhysicianOpt[]>('/api/physicians');
  const pick = (v: string) => {
    const p = list.data?.find((x) => x.id === v);
    if (p?.expired && !window.confirm(`${p.label}'s ${p.licenseState ?? 'SC'} license expired ${p.licenseExpires}. Use them anyway (for example a form signed before then)?`)) return;
    onChange(v);
  };
  const chosen = list.data?.find((x) => x.id === value);
  return (
    <>
      <select id={id} value={value} disabled={disabled || !list.data} required={required} onChange={(e) => pick(e.target.value)}>
        <option value="">{list.data ? 'Choose a physician…' : 'Loading…'}</option>
        {list.data?.map((p) => (
          <option key={p.id} value={p.id}>
            {p.label}{p.notes ? ` (${p.notes})` : ''}{p.id === suggestedId ? ' — from the signature' : ''}{p.expired ? ' (license expired)' : ''}
          </option>))}
      </select>
      {chosen?.expired && <div className="hint warn">{chosen.licenseState ?? 'SC'} license expired {chosen.licenseExpires}.</div>}
      {chosen?.notes && <div className="hint">{chosen.notes}</div>}
    </>
  );
}
